import { createSelector } from 'reselect';

import type LabelFormat from '~/types/LabelFormat';

import PackingSlipFormat from '~/types/PackingSlipFormat';

import { type ApplicationState } from '../store';

const getLabelSettingsStore = (state: ApplicationState) => state.labelSettings;

export const getDefaultPackingSlipFormat = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore): PackingSlipFormat =>
    labelSettingsStore.data.defaultPackingSlipFormat || PackingSlipFormat.PSLIP_8X11_PDF,
);

export const getDefaultLabelFormat = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore): LabelFormat => labelSettingsStore.data.defaultLabelFormat,
);

export const getLabelSettings = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore) => labelSettingsStore.data,
);

export const getIsLoadedLabelSettings = createSelector(
  getLabelSettingsStore,
  (labelSettingsStore) => labelSettingsStore.isLoadedLabelSettings,
);

export const getReferenceCharacterLimits = createSelector(
  getLabelSettingsStore,
  (
    labelSettingsStore,
  ): {
    default_shipment_reference_1_character_length: number;
    default_shipment_reference_2_character_length: number;
  } => ({
    default_shipment_reference_1_character_length: labelSettingsStore.data.refText1?.length || 0,
    default_shipment_reference_2_character_length: labelSettingsStore.data.refText2?.length || 0,
  }),
);
